export const apiCreate = (): string => '/commercial/downloads/'
export const apiList = (id?: string): string =>
  !id ? '/commercial/downloads/' : `/commercial/downloads/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/downloads/update/${id}`
export const apiDelete = (id: string): string => `/commercial/downloads/${id}`
